import { QueryKey } from "@tanstack/react-query";
import { rowChildrenKeys } from "PFApp/booking/store/provider/children_rows/query_keys";
import { adminAllocationWindowsKeys } from "PFCore/hooks/queries/admin/target_allocations/query_keys";
import { bookingMutationsKeys } from "PFCore/hooks/queries/bookings/mutation_keys";

import { mutationKeys as activitiesMutationKeys } from "../hooks/queries/activities/mutation_keys";
import { activityKeys } from "../hooks/queries/activity/query_keys";
import {
  engagementBlueprintsKeys as adminEngagementBlueprintsKeys,
  mutationKeys as adminEngagementBlueprintsMutationKeys
} from "../hooks/queries/admin/engagement_blueprints";
import { auditEngagementsMutationKeys } from "../hooks/queries/audit_planner/audit_engagements/mutation_keys";
import { auditEngagementsKeys } from "../hooks/queries/audit_planner/audit_engagements/query_keys";
import { auditRolesKeys } from "../hooks/queries/audit_planner/audit_roles/query_keys";
import { bookingKeys } from "../hooks/queries/bookings/query_keys";
import { engagementsKeys } from "../hooks/queries/engagements/query_keys";
import { profileKeys } from "../hooks/queries/profile";
import { rolesKeys } from "../hooks/queries/roles/query_keys";
import { targetAllocationMutationKeys } from "../hooks/queries/target_allocation/mutation_keys";
import { allocationWindowsKeys } from "../hooks/queries/target_allocation/query_keys";

export type InvalidationMap = Record<string, QueryKey[]>;

export const queryInvalidationMap: InvalidationMap = {
  [activitiesMutationKeys.transfer()[0]]: [
    rolesKeys.all(),
    engagementsKeys.all(),
    activityKeys.all(),
    bookingKeys.all(),
    profileKeys.all()
  ],
  [targetAllocationMutationKeys.all()[0]]: [allocationWindowsKeys.all(), adminAllocationWindowsKeys.all()],
  [auditEngagementsMutationKeys.reset()[0]]: [auditEngagementsKeys.all(), auditRolesKeys.all()],
  [adminEngagementBlueprintsMutationKeys.all()[0]]: [adminEngagementBlueprintsKeys.all()],
  [bookingMutationsKeys.replaceRange()[0]]: [rowChildrenKeys.all()]
};
